import { atom } from 'recoil';

export const langState = atom({
  key: 'langState',
  default: 'en',
});

const defaultTransform = {
  position: {
    x: 0,
    y: 0.1,
  },
  depth: 0.02,
  scale: 1.5,
};

const defaultTumbler = {
  position: {
    x: 0,
    y: 0,
  },
  depth: 0.1,
  scale: 1.15,
};

const defaultMug = {
  position: {
    x: 0,
    y: 0.1,
  },
  depth: 0.1,
  scale: 1.15,
};

export const logoTransformState = atom({
  key: 'logoTransformState',

  default: {
    mug: { ...defaultMug },

    tshirt: { ...defaultTransform },

    box: { ...defaultTransform },

    coffee: { ...defaultTransform },
    tumbler: { ...defaultTumbler },
  },
});
